import { ArrowDownIcon as PhosphorArrowDownIcon } from "@phosphor-icons/react/dist/ssr/ArrowDown";

import { createAppIcon } from "@/components/createAppIcon";

export const SouthIcon = /* @__PURE__ */ createAppIcon(PhosphorArrowDownIcon);
